import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { ReactComponent as ReviewStars } from "../../assets/reviewStars.svg";
import IconWithTextList from "../../components/common/IconWithTextList";
import { productIcons } from "../../constants/IconsWithTextData";
import ProductVariants from "../../components/product/ProductVariants";
import ProductActions from "../../components/product/ProductActions";
import ImageGallery from "react-image-gallery";
import ProductList from "../../components/product/ProductList";
import AddToCartModal from "../../components/modals/AddToCartModal";
import ProductInformationTabs from "../../components/product/ProductInformationTabs";
import { useAppContext } from "../../context/useAppContext";
import { useRequest } from "../../hooks/useRequest";
import { Skeleton } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ProductDetailsSkeleton from "../../components/skeleton/ProductDetailsSkeleton";
import GroupBuyGrid from "../../components/common/GroupBuyGrid";
import { getProductImages } from "../../utils/helper";
import CreateInstaCartModal from "../../components/modals/CreateInstaCartModal";
import { useAuth } from "../../hooks/useAuth";
import AddToWishlist from "../../components/modals/AddToWishlist";
import CreateWishlistModal from "../../components/modals/CreateWishlistModal";
import { toast } from "react-toastify";
import StarRating from "../../components/common/StarRating";
import SEO from "../../components/seo/SEO";
import { ReactComponent as AddToWishlistSvg } from "../../assets/add-to-wishlist.svg";
import { priceSymbol } from "../../utils/symbol";
import moment from "moment";
import { defaultImage } from "../../components/Image/Image";
import { staticUrl } from "../../utils/baseUrl";

const ProductDetailsStyle = styled.div`
  padding: 70px 0;
  .product__details__wrapper {
    display: flex;
    gap: 42px;
  }

   .add__to__wishlist {
    border-radius: 7.5px;
    border: 0.75px solid #ae0000;
    background: #fff;
    width: 48px;
    height: 48px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    
    &:hover {
      background-color: #ae0000;
      svg {
        path {
          fill: white;
        }
      }
    }
    svg {
      path {
        fill: #ae0000;
      }
    }
  }


  .switch{
    background: #ae0000;
    height: 16px;
    width: 30px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
    .switch_inner {
    height: 11px;
    width: 11px;
    background: white;
    border-radius: 50%;
    margin-right: 3px;
}
  .image__gallery,
  .product__details {
    width: 100%;
  }

  .attribute_box_container {
    display: flex;
    row-gap: 10px;
    flex-direction: column;
  }


  .attribute_box {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .attribute_name {
    color: #ae0000;
    width: 100%;
    font-size: 13px;
    font-weight: 500;
  }
  .attribute_button {
    border: 1px solid #8f8f8f;
    padding: 10px;
    border-radius: 5px;
    min-width: 70px;
    background: none;
    font-weight: 500;
  }
  .attribute_button:hover,
  .active_attribute {
    border: 1px solid #ae0000;
    color: #ae0000;
    background: #fbe4e4;
  }

  .image__gallery {
    .image-gallery-image {
      border-radius: 7.5px;
    }
    .image-gallery-icon:hover {
      color: #ae0000;
    }
    .image-gallery-fullscreen-button {
      top: 0;
      bottom: auto;
    }
    .image-gallery-thumbnails-container {
      text-align: left;
      margin-top: 20px;
      margin-bottom: 48px;
      .image-gallery-thumbnail {
        border-radius: 7.5px;
        border: 0px;
        overflow: clip;
      }
      .image-gallery-thumbnail + .image-gallery-thumbnail {
        margin-left: 18px;
      }
    }
  }
  .product__details {
    .vendor__details__reviews {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      .vendor__details {
        color: #303030;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.5px;
        text-decoration-line: underline;
        cursor: pointer;
        text-transform: capitalize;
      }
      .product__reviews {
        color: #303030;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.5px;
        display: flex;
        align-items: center;
        gap: 6px;
        .stars__wrapper {
          .star {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
    .product__title {
      color: #303030;
      font-size: 27px;
      font-weight: 600;
      line-height: 34.5px;
      margin-bottom: 20.5px;
      text-transform: capitalize;
    }

    .covered_box{
    border: 0.25px solid #ae0000;
    border-radius: 5px;
    padding: 10px 10px 0 5px;
    margin-bottom: 10px;
    transform: translateX(-5px)
}
.switch_green{
     max-width: 30px;
  }

    .product__price {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-top: 12px;
      .discounted__price {
        color: #ae0000;
        font-size: 42px;
        font-weight: 700;
        line-height: 51px;
      }
      .original__price {
        color: rgba(48, 48, 48, 0.5);
        font-size: 16px;
        font-weight: 400;
        line-height: 22.5px;
        text-decoration: line-through;
      }
      .limited__discount__tag {
        font-size: 8px;
        padding: 4px 10px;
        background-color: #ae0000;
        color: #fff;
        display: inline-block;
        border-radius: 4px;
      }
    }
    .product__details__options {
      margin-top: 34px;
      .product__message {
      }
    }
    .product__options {
      display: flex;
      margin-bottom: 12px;
      gap: 16px;
      .product__options__title {
        color: #303030;
        font-size: 15px;
        font-weight: 600;
        line-height: 22.5px;
        flex: 0 0 150px;
      }
      .product__options__value {
        color: #303030;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.5px;
        flex: 1;
      }
    }
  }
  .related__product {
    margin-top: 100px;
    padding: 48px 0;
    border-top: 0.75px solid rgba(48, 48, 48, 0.25);
  }
  @media (max-width: 768px) {
    padding: 0px 0 40px;
    .container {
      padding: 0 !important;
    }
    .product__details__wrapper {
      flex-wrap: wrap;
      gap: 20px;
    }
    .image__gallery .image-gallery-image {
      border-radius: 0px;
    }
    .image__gallery .image-gallery-thumbnails-container {
      margin-top: 4px;
      margin-bottom: 0px;
      .image-gallery-thumbnail {
        border-radius: 0px;
        margin-left: 4px !important;
      }
    }
    .product__details {
      padding: 0 15px;
      .vendor__details__reviews {
        margin-bottom: 4px;
        .vendor__details,
        .product__reviews {
          font-size: 12px;
          line-height: 20px;
        }
        .product__reviews {
          svg {
            width: 80px;
          }
        }
      }
      .product__title {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 10px;
      }
      .product__price .discounted__price {
        font-size: 24px;
        line-height: 32px;
      }
      .product__options {
        .product__options__title,
        .product__options__value {
          font-size: 14px;
          line-height: 22px;
        }
        .product__options__value {
          flex: 1;
        }
      }
    }
    .related__product {
      margin-top: 0;
      padding: 30px 0;
    }
  }

  .product__options__title {
    display: flex;
    align-items: center;
    gap: 8px;

    .validation-error {
      color: #ae0000;
      font-size: 12px;
      font-weight: 400;
    }
  }

  .attribute_box_container {
    margin-top: 10px;
  }

  .original__price {
  text-decoration: line-through;
  color: #888;
  margin-right: 8px;
}

.discounted__price {
  color: #e63946;
  font-weight: bold;
}

.price__meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.original__price {
  text-decoration: line-through;
  color: gray;
  font-size: 0.95rem;
}

.discount__badge {
  background-color: #f44336;
  color: #fff;
  font-size: 0.75rem;
  padding: 3px 6px;
  border-radius: 4px;
}
`;

const ProductDetails = () => {
  const [isAddToCartActive, setIsAddToCartActive] = useState(false);
  const [isInstaCartActive, setIsInstaCartActive] = useState(false);
  const [isAddToWishlistActive, setIsAddToWishlistActive] = useState(false);
  const [isCreateWishlistActive, setIsCreateWishlistActive] = useState(false);
  const { isDesktop, setIsAuthForm, setCartItemNumber } = useAppContext();
  const [
    fetchProductDetails,
    { isLoading: isFetchingProductsDetails, state: productDetailsState },
  ] = useRequest();
  const { search } = useLocation();
  const { data: productDetails } = productDetailsState || {};
  const { metaKeywords, metaDescription, metaTitle } =
    productDetails?.seo || {};
  const productName = productDetails?.name || "";
  const productCategories = productDetails?.categories || [];
  const productBrand = productDetails?.brand || null;
  const productPrice = productDetails?.discount_required ? productDetails?.discountedPrice : productDetails?.price;
  const productDiscount = productDetails?.discount;
  const productDiscountType = productDetails?.discountType;

  // Build dynamic SEO title - Always prioritize full product name
  const buildProductTitle = () => {
    // Always use full product name as primary, only use metaTitle if product name is missing
    const parts = [];

    if (productName) {
      parts.push(productName);
    } else if (metaTitle) {
      // Fallback to metaTitle only if product name is not available
      parts.push(metaTitle);
    }

    if (productBrand?.name) {
      parts.push(`by ${productBrand.name}`);
    }
    if (productCategories.length > 0 && productCategories[0]?.name) {
      parts.push(`- ${productCategories[0].name}`);
    }

    if (parts.length > 0) {
      parts.push("Building Materials | Instabuild");
      return parts.join(" ");
    }

    return "Building Materials Product | Instabuild";
  };

  // Build dynamic SEO description
  const buildProductDescription = () => {
    if (metaDescription) return metaDescription;

    const parts = [];
    if (productName) {
      parts.push(`Shop ${productName}`);
    }
    if (productBrand?.name) {
      parts.push(`by ${productBrand.name}`);
    }
    if (productPrice) {
      parts.push(`starting at $${productPrice.toFixed(2)}`);
    }
    if (productDiscount && productDiscount > 0) {
      const discountText = productDiscountType === 'percentage'
        ? `${productDiscount}% OFF`
        : `$${productDiscount} OFF`;
      parts.push(`- Save ${discountText}`);
    }
    if (productCategories.length > 0) {
      const categoryNames = productCategories.map(cat => cat?.name || cat).filter(Boolean).join(", ");
      if (categoryNames) {
        parts.push(`in ${categoryNames}`);
      }
    }
    parts.push("at Instabuild. Quality building materials and construction products with fast delivery.");

    return parts.join(" ");
  };

  // Build dynamic SEO keywords
  const buildProductKeywords = () => {
    const keywords = [];

    if (metaKeywords && metaKeywords.length > 0) {
      keywords.push(...metaKeywords);
    } else {
      if (productName) keywords.push(productName);
      if (productBrand?.name) keywords.push(productBrand.name);
      if (productCategories.length > 0) {
        productCategories.forEach(cat => {
          if (cat?.name) keywords.push(cat.name);
        });
      }
      keywords.push("building materials", "construction supplies", "building products");

      if (productDetails?.instabuild) keywords.push("InstabuildPro");
      if (productDetails?.clearance) keywords.push("clearance", "discounted");
      if (productDetails?.groupBy) keywords.push("group buy");
    }

    return keywords.join(", ");
  };

  const productSeoTitle = buildProductTitle();
  const productSeoDescription = buildProductDescription();
  const productSeoKeywords = buildProductKeywords();

  console.log(productDetails)
  const [productQuantity, setProductQuantity] = useState(1);
  const params = new URLSearchParams(search);
  const productId = params.get("id");
  const uid = params.get("uid");
  const isLoggedIn = useAuth();
  const navigate = useNavigate();
  const [addCart, { isLoading }] = useRequest();
  const [getCart] = useRequest();
  const [variation, setVariation] = useState([]);
  const [validationError, setValidationError] = useState(false);
  const [additionalPrice, setAdditionalPrice] = useState(0);
  const [isAmoled, setIsAmoled] = useState(false);

  useEffect(() => {
    if (productId) {
      const path = `/product/${productId}/`;
      fetchProductDetails({ path: path + "show" });
    }
  }, [productId]);

  useEffect(() => {
    if (uid) {
      localStorage.setItem('uid', uid);
      console.log('UID stored successfully');
    }
  }, [uid]);

  // Auto-select first variation option for each product variation
  useEffect(() => {
    if (productDetails?.variations && productDetails.variations.length > 0) {
      const initialVariations = productDetails.variations.map(element => {
        if (element.value && element.value.length > 0) {
          const firstOption = element.value[0];
          return {
            name: element.name,
            value: firstOption.value,
            price: firstOption.price
          };
        }
        return null;
      }).filter(Boolean);

      setVariation(initialVariations);

      // Calculate initial additional price
      const initialAdditionalPrice = initialVariations.reduce((total, item) =>
        total + Number(item.price), 0);
      setAdditionalPrice(initialAdditionalPrice);
    }
  }, [productDetails]);

  useEffect(() => {
    if (productDetails?.variations) {
      // Reset isAmoled when variations change
      setIsAmoled(false);

      // Check if any selected variation includes "amoled"
      const hasAmoledSelected = variation.some(item =>
        item.value.toLowerCase().includes("amoled")
      );

      setIsAmoled(hasAmoledSelected);
    }
  }, [productDetails, variation]);

  const productImages = useMemo(
    () => getProductImages(productDetails),
    [productDetails]
  );

  // Validate if all attributes are selected
  const validateVariations = (variations) => {
    if (!productDetails?.variations) return true;
    return productDetails.variations.length === variations.length;
  };

  const handleAddToCart = () => {
    if (!validateVariations(variation)) {
      setValidationError(true);
      return toast.error('Please select all attributes for this product.');
    }
    isLoggedIn ? setIsAddToCartActive(true) : setIsAuthForm(true);
  };

  const handleAddToWishlist = () => {
    console.log(productQuantity)

    if (productDetails?.variations.length > 0 && !variation.length > 0) {
      return toast.error('Please select attribute of this product.');
    }
    isLoggedIn ? setIsAddToWishlistActive(true) : setIsAuthForm(true);
  };

  const handleBuyNow = async () => {
    if (!validateVariations(variation)) {
      setValidationError(true);
      return toast.error('Please select all attributes for this product.');
    }
    if (isLoggedIn) {

      if (productDetails?.variations.length > 0 && !variation.length > 0) {
        return toast.error('Please select attribute of this product.');
      }


      const response = await addCart({
        path: `/cart`,
        method: "POST",
        body: JSON.stringify({
          productId: productId,
          quantity: productQuantity,
          deliveryDate: "",
          variation: JSON.stringify(variation ?? []),
        }),
      });
      if (!response.success) {
        return toast.error(response.message, { toastId: "error" });
      }

      // Prefetch carts to avoid delay on cart page and optimistically update count
      try {
        const path = `/cart/all?limit=20&page=1`;
        const response2 = await getCart({ path });
        if (response2?.success && Array.isArray(response2.data)) {
          // Compute total quantity once
          const totalQty = response2.data.reduce((sum, cart) => {
            const items = Array.isArray(cart.items) ? cart.items : [];
            return sum + items.reduce((s, it) => s + (Number(it.quantity) || 0), 0);
          }, 0);
          setCartItemNumber(totalQty);
          navigate(`/cart`, { state: { preloadedCarts: response2.data } });
        } else {
          // Fallback navigate without preloaded data
          navigate(`/cart`);
        }
      } catch (e) {
        navigate(`/cart`);
      }
    } else {
      setIsAuthForm(true);
    }
  };

  const handleVariation = (keyObj, valueObj) => {
    setValidationError(false); // Reset validation error when making a selection

    setVariation(prevVariations => {
      // Find if there's already a selection for this attribute
      const existingIndex = prevVariations.findIndex(
        item => item.name === keyObj.name
      );

      // If selecting a different value for the same attribute or adding new
      const newVariations = [...prevVariations];
      if (existingIndex !== -1) {
        // Subtract old price before updating
        setAdditionalPrice(prev => prev - Number(prevVariations[existingIndex].price));

        // Update existing selection
        newVariations[existingIndex] = {
          name: keyObj.name,
          value: valueObj.value,
          price: valueObj.price
        };

        // Add new price
        setAdditionalPrice(prev => prev + Number(valueObj.price));
      } else {
        // Add new selection
        newVariations.push({
          name: keyObj.name,
          value: valueObj.value,
          price: valueObj.price
        });

        // Add new price
        setAdditionalPrice(prev => prev + Number(valueObj.price));
      }
      return newVariations;
    });
  };

  return (
    <>
      <SEO
        title={productSeoTitle}
        description={productSeoDescription}
        keywords={productSeoKeywords}
        image={productDetails?.image ? `${staticUrl}/${productDetails.image}` : undefined}
      />
      <ProductDetailsStyle>
        <div className="container">
          <div className="product__details__wrapper">
            <div className="image__gallery">
              {isFetchingProductsDetails ? (
                <Skeleton variant="rectangular" width={"100%"} height={350} style={{ marginBottom: "142px" }} />
              ) : (
                <ImageGallery
                  items={productImages}
                  showBullets={false}
                  showNav={false}
                  showPlayButton={false}
                  onErrorImageURL={defaultImage}
                />
              )}
              {isDesktop && <IconWithTextList data={productIcons} />}
            </div>
            {isFetchingProductsDetails && !(productDetails && Object.keys(productDetails)?.length) ? (
              <ProductDetailsSkeleton />
            ) : (
              <div className="product__details">
                <div className="vendor__details__reviews">
                  <div className="vendor__details" onClick={() => navigate(`/seller/${productDetails?.seller?.id}`)}>
                    {productDetails?.seller?.name}
                  </div>
                  <div className="product__reviews">
                    <StarRating
                      showAvgRating={false}
                      showRatingCount={false}
                      avgRating={productDetails?.avgRating?.toFixed(1)}
                    />
                    ({productDetails?.numReviews})
                  </div>
                </div>
                <h2 className="product__title">{productDetails?.name}</h2>
                <hr style={{ borderTop: "0.75px solid rgba(48, 48, 48, 0.25)" }} />
                <div className="product__price">
                  <div className="discounted__price">
                    {priceSymbol +
                      (productDetails?.discount_required
                        ? Number(productDetails?.discountedPrice) + (isAmoled ? 15 : 0) + additionalPrice
                        : Number(productDetails?.price) + (isAmoled ? 15 : 0) + additionalPrice
                      ).toFixed(2)}
                  </div>
                  {productDetails?.discount_required && (
                    <div className="price__meta">
                      <span className="original__price">
                        {priceSymbol + (Number(productDetails?.price) + additionalPrice + (isAmoled ? 15 : 0)).toFixed(2)}
                      </span>
                      <span className="discount__badge">
                        {(() => {
                          const originalPrice = Number(productDetails?.price) + additionalPrice + (isAmoled ? 15 : 0);
                          const discountedPrice = Number(productDetails?.discountedPrice) + (isAmoled ? 15 : 0) + additionalPrice;
                          const discountAmount = originalPrice - discountedPrice;
                          const discountPercentage = Math.round((discountAmount / originalPrice) * 100);

                          return productDetails.discountType === "flat"
                            ? `Save ${priceSymbol}${discountAmount.toFixed(2)}`
                            : `Save ${discountPercentage}%`;
                        })()}
                      </span>
                    </div>
                  )}                </div>
                <div className="product__details__options">

                  <div className="product__details__options">
                    {productDetails?.price && (
                      <div className="product__options">
                        <h2 className="product__options__title">Original Price</h2>
                        <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                          {priceSymbol}{productDetails.price}
                        </p>
                      </div>
                    )}

                    {/* {additionalPrice > 0 && (
                        <div className="product__options">
                          <h2 className="product__options__title">Attribute Add-ons</h2>
                          <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                            {priceSymbol}{additionalPrice.toFixed(2)}
                          </p>
                        </div>
                      )} */}

                    {/* {isAmoled && (
                        <div className="product__options">
                          <h2 className="product__options__title">AMOLED Upgrade</h2>
                          <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                            {priceSymbol}15.00
                          </p>
                        </div>
                      )} */}

                    {/* {productDetails?.discount_required && productDetails?.discount !== undefined && productDetails?.discount !== 0 && (
                        <>
                          <div className="product__options">
                            <h2 className="product__options__title">Total Before Discount</h2>
                            <p className="product__options__value" style={{ textTransform: "capitalize", textDecoration: "line-through", color: "#888" }}>
                              {priceSymbol}{(Number(productDetails.price) + additionalPrice + (isAmoled ? 15 : 0)).toFixed(2)}
                            </p>
                          </div>
                          <div className="product__options">
                            <h2 className="product__options__title">Discount Applied</h2>
                            <p className="product__options__value" style={{ textTransform: "capitalize", color: "#4caf50" }}>
                              {productDetails.discountType === "flat"
                                ? `${priceSymbol}${productDetails.discount} off`
                                : productDetails.discountType === "percentage"
                                  ? `${productDetails.discount}% off`
                                  : `${productDetails.discount} off`}
                            </p>
                          </div>
                        </>
                      )} */}

                    {/* {productDetails?.discount !== undefined && productDetails?.discount !== 0 && (
                        <div className="product__options">
                          <h2 className="product__options__title">Final Price</h2>
                          <p className="product__options__value" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ textDecoration: "line-through", color: "gray", fontSize: "0.9rem" }}>
                              ${productDetails.price}
                            </span>
                            <strong style={{ color: "green", fontSize: "1.1rem" }}>${productDetails.discountedPrice}</strong>
                          </p>
                        </div>
                      )} */}
                  </div>

                  {productDetails?.brand && Object.keys(productDetails?.brand)?.length > 0 && (
                    <div className="product__options">
                      <h2 className="product__options__title">Brand</h2>
                      <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                        {productDetails?.brand?.name}
                      </p>
                    </div>
                  )}
                  {productDetails?.categories?.length > 0 && (
                    <div className="product__options">
                      <h2 className="product__options__title">Category</h2>
                      <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                        {productDetails?.categories?.[0]?.name}
                      </p>
                    </div>
                  )}

                  {productDetails?.specs?.slice(0, 4)?.map((item) => (
                    <div className="product__options">
                      <h2 className="product__options__title">{item?.label}</h2>
                      <p className="product__options__value">{item?.value}</p>
                    </div>
                  ))}
                  {productDetails?.stockVisibility === true && (
                    <div className="product__options">
                      <h2 className="product__options__title">Stock Left</h2>
                      <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                        {productDetails?.quantityAvailable}{" "}
                        {Number(productDetails?.quantityAvailable) > 1 ? "Products" : "Product"}
                      </p>
                    </div>
                  )}
                  <div className="product__options">
                    <h2 className="product__options__title">Weight</h2>
                    <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                      {productDetails?.weight || "-"} {productDetails?.weightUnit}
                    </p>
                  </div>

                  {productDetails?.instabuild && (
                    <div className="product__options">
                      <h2 className="product__options__title">Instabuild</h2>
                      <div className="switch">
                        <div className="switch_inner"></div>
                      </div>
                    </div>
                  )}
                  {productDetails?.clearance && (
                    <div className="product__options">
                      <h2 className="product__options__title">Clearance</h2>
                      <div className="switch">
                        <div className="switch_inner"></div>
                      </div>
                    </div>
                  )}
                  {productDetails?.groupBy && (
                    <>
                      <div className="covered_box">
                        <div className="product__options">
                          <h2 className="product__options__title">Group Buy</h2>
                          <div className="switch">
                            <div className="switch_inner"></div>
                          </div>
                        </div>
                        <div className="product__options">
                          <h2 className="product__options__title">Already Sold</h2>
                          <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                            {productDetails?.groupByOrderSold || 0}/{productDetails?.groupByOrderReach} are already sold
                          </p>
                        </div>
                        <div className="product__options">
                          <h2 className="product__options__title">Discount Amount</h2>
                          <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                            {productDetails?.groupByDiscount}
                            {productDetails?.groupByDiscountType === "flat" ? "$" : "%"} / Each Product
                          </p>
                        </div>
                        <div className="product__options">
                          <h2 className="product__options__title">Offer Starts From</h2>
                          <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                            {moment.utc(productDetails?.groupByStartDate).format("YYYY-MM-DD")}
                          </p>
                        </div>
                        <div className="product__options">
                          <h2 className="product__options__title">Offer Deadline</h2>
                          <p className="product__options__value" style={{ textTransform: "capitalize" }}>
                            {moment.utc(productDetails?.groupByEndDate).format("YYYY-MM-DD")}
                          </p>
                        </div>
                        <div className="product__options">
                          <h2 className="product__options__title">About Group Buy</h2>
                          <p className="product__options__value" style={{ textTransform: "unset" }}>
                            Purchase products in bulk to unlock special rewards in VB Coins once the maximum order
                            quantity is reached! Note: If the order quantity isn't reached before the end date, no
                            rewards will be given.
                          </p>
                        </div>
                      </div>
                    </>
                  )}

                  {productDetails?.variations && productDetails?.variations.length > 0 && (
                    productDetails?.variations.map((element) => {
                      const isSelected = variation.some(item => item.name === element.name);
                      return (
                        <div className="product__options" key={element.name}>
                          <h2 className="product__options__title">
                            {element.name}
                            {validationError && !isSelected && (
                              <span className="validation-error">*Required</span>
                            )}
                          </h2>
                          {
                            element?.value ?
                              <div className="attribute_box_container">
                                <div className="attribute_box">
                                  {element.value.map((ele) => {
                                    const isActive = variation.some(
                                      item => item.name === element.name && item.value === ele.value
                                    );
                                    return (
                                      <button
                                        className={`attribute_button ${isActive ? "active_attribute" : ""}`}
                                        key={ele.value}
                                        onClick={() => handleVariation(element, ele)}
                                      >
                                        {ele.value}
                                        {/* (+{priceSymbol}{ele.price}) */}
                                      </button>
                                    );
                                  })}
                                </div>
                              </div> : null
                          }
                        </div>
                      );
                    })
                  )}
                  {productDetails?.youtubeVideo && (
                    <div className="product__options">
                      <h2 className="product__options__title">Youtube Link</h2>
                      <a
                        href={productDetails?.youtubeVideo}
                        target="_blank"
                        className="product__options__value"
                        style={{ textTransform: "capitalize", color: "blue" }}
                      >
                        Click Here
                      </a>
                    </div>
                  )}

                  {productDetails?.quantityAvailable > 0 ? (
                    <ProductActions
                      productQuantity={productQuantity}
                      handleProductQuantity={setProductQuantity}
                      handleAddToCart={handleAddToCart}
                      handleAddToWishlist={handleAddToWishlist}
                      handleBuyNow={handleBuyNow}
                    />
                  ) : (
                    <div style={{ display: "flex", rowGap: 10, flexDirection: "column" }}>
                      <div className="add__to__wishlist" onClick={handleAddToWishlist}>
                        <AddToWishlistSvg />
                      </div>
                      <h2>Out of Stock</h2>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="product__information__tab__wrapper">
            <ProductInformationTabs
              specifications={productDetails?.specifications}
              description={productDetails?.description}
              returnText={productDetails?.returnApplicable}
              dimensions={productDetails?.dimensions}
              isDimensions={productDetails?.isDimensions}
            />
          </div>
          <div className="related__product">
            <ProductList
              listTitle={"Related Products"}
              buttonText={"View All"}
              pagination={false}
              buttonArrow={true}
              handleButtonClick={() => navigate("/search")}
              apiPath={`/product/${productId}/related`}
            />
          </div>
          <GroupBuyGrid />
        </div>
      </ProductDetailsStyle>
      {isAddToCartActive && (
        <AddToCartModal
          onMaskClick={() => setIsAddToCartActive(false)}
          handleSecondaryButtonClick={() => setIsInstaCartActive(true)}
          product={productDetails}
          quantity={productQuantity}
          variation={variation}
          isInstaCartActive={isInstaCartActive}
        />
      )}
      {isInstaCartActive && <CreateInstaCartModal onMaskClick={() => setIsInstaCartActive(false)} />}
      {isAddToWishlistActive && (
        <AddToWishlist
          onMaskClick={() => setIsAddToWishlistActive(false)}
          product={productDetails}
          handleSecondaryButtonClick={() => setIsCreateWishlistActive(true)}
          isCreateWishlistActive={isCreateWishlistActive}
        />
      )}
      {isCreateWishlistActive && <CreateWishlistModal onMaskClick={() => setIsCreateWishlistActive(false)} />}
    </>
  );
};

export default ProductDetails;
